/** @jsxImportSource @emotion/react */
import React from 'react';
import { ApproveRequestPageType } from '../../approves/ApproveRequestDetailCase';
import ApproveRequestPage from '../../approves/ApproveRequestPage';
const AuthRequestPage = () => {
  return (
    <ApproveRequestPage
      detail={{
        aprPageId: ApproveRequestPageType.ELM_AUTH_REQ,
        condition: {},
        optValCtn1: ApproveRequestPageType.ELM_AUTH_REQ,
      }}
      urlListPage="/system/auth-request-list"
    />
  );
};
export default AuthRequestPage;
